import { useQuery } from "@apollo/client";
import { Button } from "@mui/material";
import { INVALID_CUSTOMERS } from "constants/constants";
import { useAuth0 } from "contexts/AuthManager/Auth";
import { useAtom } from "jotai";
import {
  WORK_SCHEDULE_CONFIG_FULL_QUERY,
  midgardClients,
} from "providers/MidgardProvider";
import { useLocation } from "react-router";
import { errorOverlayStateAtom } from "reports/components/ErrorOverlay";
import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import { WorkScheduleConfigJsonType } from "types/types";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { ONE_SECOND_OF_MS } from "utils/timeUtils";

export function WorkSchedulesGetter() {
  const ckey = useCustomerKey();
  return ckey && !INVALID_CUSTOMERS.includes(ckey) ? (
    <WorkSchedulesGetterContent />
  ) : null;
}
function WorkSchedulesGetterContent() {
  useGetWorkScheduleConfigList();
  return null;
}

export const useGetWorkScheduleConfigList = (): void => {
  const [, setWorkScheduleConfigJsonList] = useWorkScheduleConfigJsonListAtom();
  const cKey = useCustomerKey();
  const [, setErrorOverlayState] = useAtom(errorOverlayStateAtom);
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();
  const { loading, refetch, error } = useQuery(
    WORK_SCHEDULE_CONFIG_FULL_QUERY,
    {
      client: midgardClients.get(cKey),
      variables: {},
      onError: err => {
        console.log(err);
        console.log(JSON.stringify(err));
        if ((err.networkError as any)?.statusCode === 401) {
          console.log("401 error");
          setErrorOverlayState({
            error: true,
            overrideDefaultMessage: "", // hide default message
            message: (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <p>
                  You currently don{"'"}t have access to {cKey}.
                </p>

                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      localStorage.clear();
                      loginWithRedirect({
                        appState: {
                          targetUrl: location.pathname,
                        },
                      });
                    }}
                    style={{
                      textTransform: "none",
                    }}
                  >
                    Refresh and try again
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => {
                      // open support.raven.ai in new tab
                      window.open("https://support.raven.ai", "_blank");
                    }}
                    style={{
                      textTransform: "none",
                    }}
                  >
                    Submit a support ticket
                  </Button>
                </div>
              </div>
            ),
          });
          return;
        }
        // refetch after a 10 second delay
        setTimeout(refetch, 10 * ONE_SECOND_OF_MS);
        console.log(`Work schedule query gone wrong. cKey: ${cKey}`);
        console.log(`${err}: retrying in 10 seconds`);
      },
      onCompleted: data => {
        if (data?.workScheduleConfigList && !loading && !error) {
          setWorkScheduleConfigJsonList(
            data.workScheduleConfigList as WorkScheduleConfigJsonType[]
          );
        }
      },
    }
  );
};
